<ul class="password-strength__items">
  <li class="password-strength__item" [style.background-color]="bar0"></li>
  <li class="password-strength__item" [style.background-color]="bar1"></li>
  <li class="password-strength__item" [style.background-color]="bar2"></li>
  <li class="password-strength__item" [style.background-color]="bar3"></li>
</ul>

<div class="password-strength__label" [style.color]="bar0">{{ label }}</div>
